import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';
import { IRfq } from '../../interfaces/Rfq';
import { IVendorBidItem } from '../../interfaces/VendorBid';
import { unwrapResolvedMetadata } from '@angular/compiler';

interface DialogData {
  data: IRfq,
  index: number,
  currency: string
}
@Component({
  selector: 'app-fill-part-level-cost',
  templateUrl: './fill-part-level-cost.component.html',
  styleUrls: ['./fill-part-level-cost.component.scss']
})
export class FillPartLevelCostComponent implements OnInit {

  rowData: IRfq;
  enquiryId;
  vendorOrderItems: any = [];
  partDetails: IVendorBidItem;
  currentIndex;
  costUpdateForm: FormGroup;
  initial;
  actual_date: any;
  todayDate: Date = new Date();
  currentTabIndex: number = 0;
  currency: string = 'INR';
  constructor(
    public dialogref: MatDialogRef<FillPartLevelCostComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private adminService: AdminService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.rowData = this.data.data;
    this.currentIndex = this.data.index;
    this.currency = this.data.currency;
    this.rowData.vendor_bid_items.filter(x => this.vendorOrderItems.push(x.id));
    this.enquiryId = this.rowData.id;
    this.setPartId(this.vendorOrderItems[this.currentIndex]);
  }

  setPartId(id) {
    const itemIndex = this.vendorOrderItems.findIndex(ele => ele === id);
    this.currentIndex = itemIndex;
    return this.getPartDetails(this.enquiryId, this.vendorOrderItems[this.currentIndex]);
  }

  getPartDetails(rfqId, itemId) {
    this.adminService.getVendorItemDetails(rfqId, itemId).subscribe(
      (res: any) => {
        this.partDetails = res.body;
        return this.intializeCostingForm(this.partDetails);
        // return this.intializeForm(this.partDetails.time, this.partDetails.item_rate, this.partDetails.vendor_comments, this.partDetails.hsn_code, this.partDetails.taxation, this.partDetails.expected_date, this.partDetails.actual_date)
      },
      (err) => {
        this.partDetails = undefined;
      }
    );
  }

  intializeCostingForm(partDetails: IVendorBidItem) {
    this.costUpdateForm = this.formBuilder.group(
      {
        bid_item_batches: this.formBuilder.array([]),
      }
    )
    partDetails.dispatch_batch.forEach(batch => {
      const costing = batch?.costing
      let unitPrice = costing?.total_unit_cost;
      if (!unitPrice) {
        // For the first time when vendor as hasnot set their target price yet
        unitPrice = this.getCustomerTargetUnitPrice(partDetails);
      }
      this.intializeForm(batch?._id, costing?.lead_days, unitPrice, costing?.comment, costing?.hsn_code, costing?.tax_cost, batch?.dispatch_date, costing?.actual_date, costing?.agreed_quantity, batch?.dispatch_quantity, batch?.name)
      this.itemRateChange(batch?._id)
    })
  }

  getCustomerTargetUnitPrice(vendorBidItem: IVendorBidItem): number {
    return this.rowData.vendor_bid_items.filter(bi => bi.cart_item_id === vendorBidItem.cart_id)[0].targetPrice;
  }

  get bidItemBatchesArray() {
    return this.costUpdateForm.get("bid_item_batches") as FormArray;
  }

  intializeForm(id: number, time: number, item_rate: number, vendor_comments: string, hsn_code: string, taxation: number, expected_date: Date, actual_date: string, agreed_quantity: number, dispatch_quantity: number, batch_name: string) {
    this.bidItemBatchesArray.push(
      this.formBuilder.group({
        'id': id,
        'dispatch_quantity': dispatch_quantity,
        'time': new FormControl(time, [Validators.required, Validators.minLength(1)]),
        'item_rate': new FormControl(item_rate, [Validators.required]),
        'vendor_comments': new FormControl(vendor_comments),
        'hsn_code': new FormControl(hsn_code, [Validators.required]),
        'taxation': new FormControl(taxation),
        'expected_date': new FormControl(expected_date),
        'actual_date': new FormControl(actual_date),
        'agreed_quantity': new FormControl(agreed_quantity, [Validators.required]),
        'name': batch_name
      })
    );
  }

  previousPart() {
    if (this.vendorOrderItems?.length === 1) {
      return;
    }
    this.partDetails = undefined;
    if (this.currentIndex == 0) {
      this.setPartId(this.vendorOrderItems[this.vendorOrderItems.length - 1])
    }
    else {
      this.setPartId(this.vendorOrderItems[this.currentIndex - 1])
    }
  }

  nextPart() {
    if (this.vendorOrderItems?.length === 1) {
      return;
    }
    this.partDetails = undefined;
    if (this.currentIndex == this.vendorOrderItems.length - 1) {
      this.setPartId(this.vendorOrderItems[0])
    }
    else {
      this.setPartId(this.vendorOrderItems[this.currentIndex + 1])
    }
  }

  close() {
    this.dialogref.close();
  }

  itemRateChange(id) {
    console.log("ID", id)
    const index = this.partDetails?.dispatch_batch?.findIndex(item => item?._id === id)
    this.partDetails.dispatch_batch[index].sub_total = Number(this.costUpdateForm.value.bid_item_batches[index].item_rate) * (this.costUpdateForm.value.bid_item_batches[index].agreed_quantity || this.costUpdateForm.value.bid_item_batches[index].dispatch_quantity);
    this.partDetails.dispatch_batch[index].total_cost = this.partDetails.dispatch_batch[index].sub_total + this.partDetails.dispatch_batch[index].sub_total * Number(this.costUpdateForm.value.bid_item_batches[index].taxation || 0) / 100;
    const agreedQtyControl = this.bidItemBatchesArray.controls[index].get('agreed_quantity');
    const taxationControl = this.bidItemBatchesArray.controls[index].get('taxation');
    if(agreedQtyControl?.value < 0 ){
      this.toastr.error('You can not choose negative quantity','Error!');
      agreedQtyControl.setValue(0);
    }
    if(taxationControl?.value < 0 ){
      this.toastr.error('You can not choose negative quantity','Error!');
      taxationControl.setValue(0);
    }
    
  }

  submitCost() {
    // if(this.costUpdateForm['actual_date'] || this.costUpdateForm.value.vendor_order_item?.actual_date){
    if (this.isRequiredFieldInValid()) {
      this.toastr.error(
        'Required fields missing', ''
      );
      return;
    }
    this.adminService.updateVendorOrderItem(this.enquiryId, this.vendorOrderItems[this.currentIndex], this.costUpdateForm.value).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.dialogref.close({ data: res.body });
          this.toastr.success('Cost Updated for the part', 'Success');
        }
      },
      err => {
        this.toastr.error('Something went wrong', 'Error');
        console.log(err)
      }
    )
  }

  downloadModelFile() {
    window.open(this.partDetails.model_attributes.model_file_url)
  }

  downloadDrawing() {
    if (this.partDetails.drawings.length == 0 && this.partDetails?.techfiles?.length == 0) {
      this.toastr.info('There are No 2D Files to Download', 'info');
    }
    else {
      for (var i = 0; i < this.partDetails.drawings.length; i++) {
        window.open(this.partDetails.drawings[i].drawing_file.url, "_blank");
      }
      for (var i = 0; i < this.partDetails?.techfiles?.length; i++) {
        window.open(this.partDetails?.techfiles[i]?.tech_file?.url, "_blank")
      }
      this.toastr.success('All the 2D files are downloaded', 'Success');
    }
  }

  downloadCustomInspectionFile() {
    if (this.partDetails?.custom_inspection_files?.length == 0) {
      this.toastr.info('There are no custom-inspection files to download', 'Info');
    }
    else {
      for (let i = 0; i < this.partDetails.custom_inspection_files.length; i++) {
        window.open(this.partDetails.custom_inspection_files[i].custom_inspection_file.url, "_blank")
      }
      this.toastr.success('Files have been downloaded', 'Success')
    }
  }

  viewer() {
    this.adminService.navigateToCalculate(this.partDetails.cleaned_model_attributes.id)
  }

  OnDateChange(event, i) {
    this.actual_date = event.target.value;
    this.costUpdateForm.value["bid_item_batches"][i]['actual_date'] = this.actual_date;
    const tentativeBidAwarddate = this.partDetails?.dispatch_batch[i]?.dispatch_date; //this.partDetails?.tentative_quote_award_date; //TODO: This was correct earlier
    this.costUpdateForm.value["bid_item_batches"][i]['time'] = this.calculateDaysDifference(this.actual_date, tentativeBidAwarddate);
  }

  private calculateDaysDifference(actualDate: string, expectedDeliveryDate: Date): number {
    // Get today's date
    // const today = moment();
    const expectedDate = moment(expectedDeliveryDate);
    // Parse the provided date string into a Moment object
    const givenDate = moment(actualDate);
    // Calculate the difference in days
    const difference = givenDate.diff(expectedDate, 'days');
    // Return the calculated difference
    console.log(difference);
    return difference;
  }

  onTabChange(event: MatTabChangeEvent) {
    const tabIndex = event.index;
  }

  isRequiredFieldInValid(): boolean {
    return this.costUpdateForm.value["bid_item_batches"].some(batch => {
      return batch?.item_rate === null || batch?.hsn_code === '' || batch?.item_rate === 0 || batch?.actual_date === undefined
    })
  }

}